import React from 'react'
import PropTypes from 'prop-types'
import Api from '#services/api'
import AbteilungenVerwaltenModal from '#components/m/AbteilungenVerwaltenModal'

function ManageAbteilungenButton({currentUserId, abteilungen, refreshAbteilungen}) {

  const saveAbteilungen = async ({abteilungenIds}) => {
    await Api.updateAbteilungenAsFachausbilder(abteilungenIds)
    refreshAbteilungen();
  }

  return (
    <AbteilungenVerwaltenModal
      triggerButtonModifier='meine-azubis__abteilungen-verwalten'
      ausbilder={{
        id: currentUserId,
        abteilungen,
      }}
      handleSave={saveAbteilungen}
    />
  )
}

ManageAbteilungenButton.propTypes = {
  currentUserId: PropTypes.number.isRequired,
  abteilungen: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
  ),
  refreshAbteilungen: PropTypes.func.isRequired,
}


export default ManageAbteilungenButton
